import { cn } from '@/shared/lib/cn';
import { HistoryCellView } from './HistoryPill';
import { HISTORY_COLUMNS, type HistoryRow } from './historyRows';
import type { DynamicPricingHistoryView } from '@/shared/api';

/** Spalten nach Board „Verlauf“; die gewählte Zeile trägt den Waldstrich links. */
export function HistoryTable({
  view,
  rows,
  selectedId,
  onSelect,
}: {
  view: DynamicPricingHistoryView;
  rows: HistoryRow[];
  selectedId?: string;
  onSelect: (id: string) => void;
}) {
  const { labels, grid } = HISTORY_COLUMNS[view];
  return (
    <div className="min-w-0">
      {/* Spaltenköpfe nur fürs Auge; jede Zeile ist ein Knopf mit ihrem ganzen Text. */}
      <div
        aria-hidden
        className="text-ink-soft grid gap-3 px-[18px] py-2.5 font-mono text-[10px] uppercase tracking-[0.12em]"
        style={{ gridTemplateColumns: grid }}
      >
        {labels.map((label) => (
          <span key={label} className="truncate">
            {label}
          </span>
        ))}
      </div>
      <ul aria-label="Einträge">
        {rows.map((row) => {
          const selected = row.id === selectedId;
          return (
            <li key={row.id}>
              <button
                type="button"
                aria-pressed={selected}
                onClick={() => onSelect(row.id)}
                className={cn(
                  'border-paper grid w-full items-center gap-3 border-t px-[18px] py-3 text-left',
                  selected
                    ? 'bg-forest-soft/50 shadow-[inset_3px_0_0_var(--color-forest)]'
                    : 'hover:bg-paper',
                )}
                style={{ gridTemplateColumns: grid }}
              >
                {row.cells.map((cell, index) => (
                  <span key={labels[index]} className="flex min-w-0">
                    <HistoryCellView
                      cell={cell}
                      className={cn(index === 0 && 'font-mono text-xs', index === 1 && 'font-bold')}
                    />
                  </span>
                ))}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
